"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackFilterInteraction = void 0;
const pushToDataLayer_1 = require("./pushToDataLayer");
const trackGA4EventWithCleanUp_1 = require("./trackGA4EventWithCleanUp");
const enums_1 = require("../enums");
function trackFilterInteraction(action, value, GA4Data, activeFilters) {
    const basicEventData = {
        event: 'JS_Event',
        eventCategory: 'Filter',
        eventAction: action,
        eventLabel: value,
    };
    if (GA4Data?.eventName &&
        (GA4Data?.filter_type ||
            GA4Data?.notification_type ||
            GA4Data?.click_element ||
            GA4Data?.list_type)) {
        (0, trackGA4EventWithCleanUp_1.trackGA4EventWithCleanUp)({
            ...basicEventData,
            eventData: {
                ...GA4Data,
                eventName: GA4Data.eventName,
                feature_category: enums_1.GA4FeatureCategory.Filter,
            },
            active_filter_types: activeFilters,
        });
    }
    else {
        (0, pushToDataLayer_1.pushToDataLayer)(basicEventData);
    }
}
exports.trackFilterInteraction = trackFilterInteraction;
//# sourceMappingURL=trackFilterInteraction.js.map